class CardBlock {
    constructor (context, settings, $) {
        // Environment variables
        this.context = context;
        this.settings = settings;
        this.$ = $;

        this.$window = this.$(window);
        this.$cardBlock = this.$('.js-card-block', this.context).once();
        this.$card = this.$('.js-card', this.context).once();

        this.$window.on('load', () => {
            if ('IntersectionObserver' in window &&
                'IntersectionObserverEntry' in window &&
                'intersectionRatio' in window.IntersectionObserverEntry.prototype) {

                this.observeCards();

                this.$card.removeClass('is-visible');
            }
        });
    }

    observeCards () {
        const cardObserver = new IntersectionObserver((entries) => {
            entries.forEach(entry => {
                if (entry.isIntersecting) {
                    this.$(entry.target).addClass('is-visible');
                }
            });
        }, {threshold: 0.3});

        this.$card.each((index) => {
            cardObserver.observe(this.$card[index]);
        });
    }
}

export default CardBlock;
